var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CanvasConnectedComponent } from "../generic/CanvasConnectedComponent";
var SceneLayer = /** @class */ (function (_super) {
    __extends(SceneLayer, _super);
    function SceneLayer() {
        var _this = _super.call(this) || this;
        _this._worldWidth = 0;
        _this._worldHeight = 0;
        _this.setWorldDimensions = _this.setWorldDimensions.bind(_this);
        return _this;
    }
    SceneLayer.prototype.setWorldDimensions = function (width, height) {
        this._worldWidth = width;
        this._worldHeight = height;
    };
    Object.defineProperty(SceneLayer.prototype, "worldWidth", {
        get: function () {
            return this._worldWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SceneLayer.prototype, "worldHeight", {
        get: function () {
            return this._worldHeight;
        },
        enumerable: true,
        configurable: true
    });
    return SceneLayer;
}(CanvasConnectedComponent));
export { SceneLayer };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/SceneLayer.ts
// module id = 253
// module chunks = 3